export default __webpack_public_path__ + "static/media/login-tilte-mobile.e27f891a.svg";